export default __webpack_public_path__ + "static/media/yellowWarning.46954231.svg";